<!--
 * @Author: Czy
 * @Date: 2021-08-23 10:54:39
 * @LastEditTime: 2021-12-23 16:10:37
 * @FilePath: /plant-protection-association/src/components/Footer.vue
 *  
-->
<template>
  <div id="footer" class="container-fluid">
    <div class="container">
      <div class="row footer-box">
        <div class="footer-left">
          <div class="logo">
            <img :src="topIcon" alt="logo图" />
          </div>
          <p class="title">{{ companyName }}</p>
          <p class="address_tel_fax bottom-item">
            <span>地 址：{{ companyAddress }}</span>
          </p>

          <p class="email_wx bottom-item">
            <span>邮箱：{{ companyEmail }}</span>
          </p>
          <p class="email_wx bottom-item">
            <span>网址：{{ companyWebsite }}</span>
          </p>
          <p class="email_wx bottom-item">
            <span>电话：{{ companyPhone }}</span>
          </p>
        </div>
        <div class="footer-right">
          <div class="associated-media">合作媒体</div>
          <div class="associated-media-comtent"><a  target="_blank" :href="item.linkUrl" v-for="(item,idx) in media" key="idx" class="aLink">{{item.linkName}}</a></div>
        </div>
        <!-- <p class="tel-box">电 话：180 3001 7711、180 5003 1250、180 5003 1267、<br> 180 3001 7733、183 4502 7077、180 3001 2277</p> -->
<!-- <a href="http://"></a> -->
        <a target="_blank" href="https://beian.miit.gov.cn/" class="copy">{{ domainNameRecord }}</a>
      </div>
    </div>
  </div>
</template>
<script>
import { getHome ,getmediaLink} from "@/api/api";
export default {
  name: "Footer",
  data() {
    return {
      //公司地址
      companyAddress: "",
      //公司邮箱
      companyEmail: "",
      //公司名称
      companyName: "",
      //公司电话
      companyPhone: "",
      //公司地址
      companyWebsite: "",
      //合作媒体
      media:[],
      //域名备案
      domainNameRecord: "",
      //公司图标
      topIcon: "",
    };
  },
  created() {
    this.getCompany();
    this.getMedia();
    this.getDomainNameRecord();
    this.getTopIcon();
  },
  methods: {
    //获取公司基本信息
    async getCompany() {
      const res = await getHome("company_");
      console.log("获取公司基本信息", res);
      if (res.code == 200) {
        let {
          company_address,
          company_email,
          company_name,
          company_phone,
          company_website,
        } = res.data;
        this.companyAddress = company_address;
        this.companyEmail = company_email;
        this.companyName = company_name;
        this.companyPhone = company_phone;
        this.companyWebsite = company_website;
      }
    },
    //获取合作媒体
    async getMedia() {
      const res = await getmediaLink();
      console.log("获取合作媒体", res);
      if (res.code == 200) {
        this.media = res.data;
      }
    },
    //获取域名备案
    async getDomainNameRecord() {
      const res = await getHome("domainNameRecord");
      console.log("获取域名备案", res);
      if ((res.code = 200)) {
        this.domainNameRecord = res.data.domainNameRecord;
      }
    },
    //获取图标
    async getTopIcon() {
      const res = await getHome("topIcon");
      console.log("获取图标", res);
      if (res.code == 200) {
        this.topIcon = res.data.topIcon;
      }
    },
  },
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  background: url("../../static/footer_bgc.png") no-repeat 0 0 /100% 100%;
}
.footer-box {
  overflow: hidden;
  text-align: center;
  color: #fff;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  padding: 30px 15px 30px 15px;
}
.footer-left {
  width: 40%;
}
.footer-right {
  width: 60%;
  padding: 39px 0 20px 68px;
  display: flex;
  flex-direction: row;
}
.associated-media {
  width: 70px;
  height: 80px;
  /* padding:4px 4px; */
  margin: 0 10px;
  font-size: 25px;
  background-color: #2c8ad3;
}
.associated-media-comtent {
  width: 600px;
  font-size: 14px;
  line-height: 2;
  /* background-color: red; */
  text-align: left;
}
.logo {
  width: 200px;
  max-height: 400px;
  margin: 10px auto 20px;
}
.logo img {
  width: 100%;
  height: 100%;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #fff;
  font-size: 14px;
  margin: 10px 0;
  
}
.email_wx {
  color: #fff;
  font-size: 14px;
}
.copy {
  color: #fff;
  font-size: 14px;
  margin: 20px 0 10px;
}
.bottom-item{
  /* background-color:red; */
  /* text-align:left; */
  /* padding-left: 40px; */
  display: flex;
  justify-content: center;
}

.bottom-item span{
/* background-color: green; */
width: 270px;
text-align: left;
}


@media screen and (max-width: 997px) {
  #footer {
    padding: 30px 10px;
  }
  .footer-box {
    padding: 0;
  }
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 5px 0;
  }
  .footer-left {
    width: 100%;
  }
  .footer-right {
    width: 100%;
    /* max-width:760px; */
    padding: 5px 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .associated-media {
    width: 70px;
    height: 80px;
    margin: 0 1px 0 0;
    font-size: 26px;
    background-color: #2c8ad3;
  }
  .associated-media-comtent {
    width: 240px;
    font-size: 14px;
    line-height: 2;
  }

 
}
a{
  color: #fff;
  font-size: 14px;
  margin: 4px;
  text-decoration:none；
}
a:link{ text-decoration:none; } 
a:visited{ text-decoration:none; } 
a:hover{ text-decoration:none; } 
a:active{text-decoration:none; } 

</style>




// WEBPACK FOOTER //
// src/components/Footer.vue